module.exports = __webpack_public_path__ + "static/media/content1Img.8f871bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/aboutUs/img/content1Img.png
// module id = 272
// module chunks = 0